var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconErrorS(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_error_s") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_error_s",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.9376881,4.77118867 C12.4198173,3.79298818 11.5779827,3.79714377 11.0623119,4.77118867 L3.93768812,18.2288113 C3.41981727,19.2070118 3.8926228,20 4.99508929,20 L19.0049107,20 C20.1067681,20 20.5779827,19.2028562 20.0623119,18.2288113 L12.9376881,4.77118867 Z",
    id: "Page-1",
    fill: "#C60000"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-25",
    transform: "translate(11.000000, 8.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1,7 L1,7 C0.448,7 0,6.552 0,6 L0,1 C0,0.448 0.448,0 1,0 L1,0 C1.552,0 2,0.448 2,1 L2,6 C2,6.552 1.552,7 1,7",
    id: "Fill-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1,10 L1,10 C0.448,10 0,9.552 0,9 L0,9 C0,8.448 0.448,8 1,8 L1,8 C1.552,8 2,8.448 2,9 L2,9 C2,9.552 1.552,10 1,10",
    id: "Fill-3"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconErrorS);
export default __webpack_public_path__ + "static/media/icon_error_s.d97e77f4d04517b45e1a28827446af9b.svg";
export { ForwardRef as ReactComponent };